// Module
var code = "<div class=\"aspectratio\"> <iframe id=\"vmplayer\" class=\"embeddedplayer\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> </div>";
// Exports
module.exports = code;